import { Roarr as log } from "roarr";

import type { GridStackTile } from "../../../types/tile";
import { getRuntimeTrayLayout } from "../../trayLayout";
import { arrangeTilesWithoutGaps } from "./arrangeWithoutGaps";
import type { TileArranger } from ".";

export const arrangeTilesWithGaps: TileArranger = (tiles) => {
    let outputTiles: GridStackTile[] = [];
    const { columns, rows } = getRuntimeTrayLayout();

    let x = 0;
    let y = 0;
    for (const sortedTiles of tiles) {
        if (x + sortedTiles.length >= columns) {
            y++;
            x = 0;
        }

        if (y > rows - 1) {
            log.warn(
                "Too many tiles to arrange with gaps; arranging without gaps"
            );
            return arrangeTilesWithoutGaps(tiles);
        }

        for (const sortedTile of sortedTiles) {
            outputTiles = [
                ...outputTiles,
                {
                    colour: sortedTile.Colour,
                    tileType: sortedTile.TileType,
                    x,
                    y,
                    staging: false,
                },
            ];
            x++;
        }
        x++;
    }

    return outputTiles;
};
